export default __webpack_public_path__ + "sounds/Music-c9393ece54d57d0ae195d64c0670f8d8.mp3";